module.exports = __webpack_public_path__ + "assets/img/station5.9dbd6bbe.png";